import axios from "axios";

export const URL = "https://court.gov.tm";

const axiosInstance = axios.create({
  baseURL: `${URL}/api/`,
  timeout: 15000,
  headers: {
    Accept: "application/json",
  },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "API request failed";

    return Promise.reject({
      message,
      status: error?.response?.status,
      data: error?.response?.data,
    });
  }
);

export default axiosInstance;